import styled from "styled-components";

const VideoDetailsContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-radius: 8px;
`;

const VideoThumbnail = styled.div`
  width: ${(props) => props.width || "50px"};
  height: ${(props) => props.height || "50px"};
  background: ${({ theme }) => theme.colors.grey};
  border-radius: 100% !important;
  overflow: hidden;
  min-width: ${(props) => props.width || "50px"};
  min-height: ${(props) => props.height || "50px"};
`;

const ThumbnailImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${(props) => `url("${props.img}")`};
  border-radius: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;

const Tag = styled.div`
  min-width: fit-content;
  padding: 6px 12px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 12px;
  border-radius: 30px;
  text-align: ${(props) => props.textAlign || "start"};
`;

const DescriptionContainer = styled.div`
  background: ${({ theme }) => theme.colors.lightGrey};
  padding: 16px;
  border-radius: 6px;
  line-height: 1rem;
`;

export {
  VideoDetailsContainer,
  VideoThumbnail,
  ThumbnailImage,
  Tag,
  DescriptionContainer,
};
